import React from "react";
import styled from "styled-components";
import { SafetyInspectionFacility, safetyInspectionSummaryHelper } from "../../../../amorg-common";
import { Button } from "../../../../designSystem/button/Button";
import { colors } from "../../../../designSystem/colors/color";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../designSystem/compositeComponents/ListRow";
import { StatusCounter } from "../../../../designSystem/compositeComponents/StatusCounter";
import { DeviceView } from "../../../../designSystem/DeviceView";
import { Small } from "../../../../designSystem/typography/Body";
import { H3 } from "../../../../designSystem/typography/Heading";
import { getFacilityTypeIcon } from '../../../../utils/facilityHelper';
import { InspectionPanel } from "./InspectionPanel";
import { InspectionPointSelectorModal } from "./InspectionPointSelectorModal";

type FacilityPanelProps = {
    activityId:string,
    locationId:string
    facility:SafetyInspectionFacility,
    onUpdate:()=>void
}

export function FacilityPanel(props:FacilityPanelProps):JSX.Element
{
    const inspections = props.facility.inspectionPoints;
    const [expanded, setExpanded] = React.useState(true);
    const [showEdit, setShowEdit] = React.useState(false);

    const summary = safetyInspectionSummaryHelper.getFacilityInspectionSummary(props.facility);
    let color = colors.text.normal;
    if(summary.state === 'completed-all-passed')
        color = colors.text.state.success;
    else if(summary.failed > 0)
        color = colors.text.state.error;


    const sharedComponent =
    <Flex flexDirection="column" style={{flexGrow:2}} justifyContent="stretch" alignItems="flex-start" gap={4}>
        <div>
            {summary.state === 'completed-all-passed' && <StyledStatusText>Alle kontrolpunkter godkendt</StyledStatusText>}
            {summary.state === 'completed' && <StyledStatusText>Kontrol gennemført</StyledStatusText>}
            {summary.state === 'in-progress' && <StyledStatusText>Kontrol under afvikling</StyledStatusText>}
            {summary.state === 'not-started' && <StyledStatusText>Kontrol ikke påbegyndt</StyledStatusText>}
            {summary.state === 'no-inspections' && <StyledStatusText>Ingen kontrolpunkter oprettet</StyledStatusText>}
        </div>
        <Flex flexDirection="row" gap={16}>
            <StatusCounter icon='status_ok' iconColor={colors.icon.success} text='Godkendt' count={summary.passed} />
            <StatusCounter icon='status_error' iconColor={colors.icon.error} text='Ikke godkendt' count={summary.failed} />
            <StatusCounter icon='status_error' iconColor={colors.icon.pending} text='Ikke kontrolleret' count={summary.notStarted} />
        </Flex>
    </Flex>


    return (
        <>
            <ListRow
                stripColor={color}
                styleVariant="lightGray"
                level={2}
                icon={getFacilityTypeIcon(props.facility.facilityType.id)}
                childRows={[
                    inspections.map(i =>
                        <InspectionPanel key={i.inspectionResult.id} activityId={props.activityId} inspection={i} />
                    )
                ]}
                collapsed={!expanded}
                onCollapse={
                    inspections.length > 0
                        ? (collapsed)=>setExpanded(!collapsed)
                        : undefined
                }
                content={
                    <Flex flexDirection='row' gap={24} alignItems="center" style={{marginLeft:'10px'}}>
                        <Flex flexDirection="column" width="200px">
                            <H3 color="gray">{props.facility.name}</H3>
                            <Small>{props.facility.facilityType.name}</Small>
                        </Flex>
                        
                        <DeviceView
                            tablet={sharedComponent}
                            desktop={sharedComponent} />
                        
                        
                        <div style={{justifySelf:'right'}}>
                            <Button variant={'text'} icon={'interface_actions_edit'} onClick={() => setShowEdit(true)} />
                            <InspectionPointSelectorModal 
                                activityId={props.activityId}
                                locationId={props.locationId}
                                facility={props.facility}
                                showModal={showEdit} onClose={()=>setShowEdit(false)}
                                onUpdate={props.onUpdate} />
                        </div>
                    </Flex>
                } />
        </> 
    );
}

const StyledStatusText = styled.span`
    font-size: 12px;
    font-weight: 600;
    padding: 4px 0px;
    border-radius: 8px;
`;